import React from "react";

import "./PaginationResultStats.scss";

export interface IPaginationResultStatsProps {
  page: number;
  itemsPerPage: number;
  itemsTotal: number;
  textTemplate: string;
  "data-testid"?: string;
}

const PaginationResultStats = (props: IPaginationResultStatsProps) => {
  const { page = 1, itemsPerPage, itemsTotal } = props;

  const start = itemsTotal ? itemsPerPage * (page - 1) + 1 : 0;
  const end = Math.min(start + itemsPerPage - 1, itemsTotal);

  const text = props.textTemplate
    .replace("{resultFrom}", String(start))
    .replace("{resultTo}", String(end))
    .replace("{resultTotal}", String(itemsTotal));

  return (
    <div
      className="c-pagination-result-stats"
      data-testid={props["data-testid"]}
    >
      {text}
    </div>
  );
};

export default React.memo(PaginationResultStats);
